<script>
import FeatureInput from '@/components/cars/edit/FeatureInput.vue'
import { PRESETS } from '@/mixins/SharedServiceData'

export default {
  components: {
    'mia-feature-input': FeatureInput
  },

  computed: {
    dateTo() {
      return this.$store.state.service.filters.global.dateTo
    }
  },

  methods: {
    onInput(dateTo) {
      if (dateTo) {
        this.$store.commit('service/setGlobalDateTo', dateTo)
        this.$store.commit('service/setGlobalPreset', PRESETS.custom)
      }
    }
  }
}
</script>

<template>
  <mia-feature-input
    v-bind="$attrs"
    :value="dateTo"
    label="Datum bis"
    type="date"
    v-on="$listeners"
    @input="onInput"
  />
</template>
